/**
 * Extracts a human-readable message from an axios error.
 * Handles FastAPI shapes (detail string, detail validation array),
 * generic { message } / { error } payloads, and plain string bodies.
 */
export const parseApiError = (error, fallback = 'An error occurred.') => {
  const data = error?.response?.data

  if (typeof data === 'string' && data.trim()) return data

  if (data && typeof data === 'object') {
    if (typeof data.detail === 'string' && data.detail.trim()) {
      return data.detail
    }
    if (Array.isArray(data.detail) && data.detail.length > 0) {
      const formatted = data.detail
        .map((d) => {
          const loc = Array.isArray(d?.loc) ? d.loc.slice(1).join('.') : ''
          const msg = d?.msg ?? d?.message ?? ''
          return loc ? `${loc}: ${msg}` : msg
        })
        .filter(Boolean)
        .join('; ')
      if (formatted) return formatted
    }
    if (typeof data.message === 'string' && data.message.trim()) {
      return data.message
    }
    if (typeof data.error === 'string' && data.error.trim()) {
      return data.error
    }
  }

  if (error?.message) return error.message
  return fallback
}
